import { routeMap } from './routeMap';
import type { RouteMap } from '@/scripts/router/types';
import Paths from './paths';
import { genRoutesMap } from '@/scripts/router';

import App from '@/App';
import Main from '@/pages/main';

// Configure the element here separately to avoid load order problems when reading menu data
export const routeMapRuntime: RouteMap = genRoutesMap(
  {
    [Paths.BASE]: {
      element: <App></App>,
    },
    [Paths.MAIN]: {
      element: <Main></Main>,
    },
  },
  routeMap
);
